import { Box, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import styles from "./ConfirmationModal.styles";
import SecureSyncModal from "src/components/common/SecureSyncModal/SecureSyncModal";

const ConfirmationModal = ({ open, handleConfirm, onClose, count }) => {
    const { t } = useTranslation();
    return (
        <SecureSyncModal
            open={open}
            title={t("userDetails.multipleUserSelectPopupTitle")}
            footer={
                <Box sx={styles.confirmationModalFooter}>
                    <Button variant="contained" color="primary" onClick={handleConfirm}>
                        {t("buttonLabels.ok")}
                    </Button>
                    <Button autoFocus variant="outlined" onClick={onClose}>
                        {t("buttonLabels.cancel")}
                    </Button>
                </Box>
            }
        >
            <Trans
                i18nKey={"userDetails.multipleUserSelectPopup"}
                values={{
                    count: count ? count : "",
                }}
            />
        </SecureSyncModal>
    );
};

export default ConfirmationModal;
